import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ModalConfirm from '../../../../../../components/Modal/ConfirmLayouts';
import Loader from '../../../../../../components/Loaders/Loader';
import { MainContext } from '../../../index';

import { getErrorMessage } from '../../../../../../utils/helper';
import { STATUSES } from '../../../constants/statuses';
import { changeStatusSuccess, modalClose } from '../../../reducer';
import { changeRefillStatusUrl } from '../../../../../../services/endpoints/refill';

const ModalChangeStatus = () => {
  const [store, dispatch] = useContext(MainContext);
  const { modal } = store;

  const [form, setForm] = useState({
    isLoading: false,
    limitError: false,
    limitHeader: null,
    limitMessage: null,
    error: null,
    success: false,
    id: null,
    status_id: null,
    status: null,
  });
  const { isLoading, error, success, limitError, limitHeader, limitMessage, id, status, status_id } = form;

  useEffect(() => {
    setForm((prevState) => ({
      ...prevState,
      id: modal.data.id,
      status_id: modal.data.status_id,
      status: STATUSES[modal.data.status_id],
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onCloseModal = () => {
    dispatch(modalClose())
  }

  const onConfirm = async () => {
    try {
      setForm((prevState) => ({
        ...prevState,
        error: null,
        isLoading: true,
      }));
      const response = await changeRefillStatusUrl(id, status_id);
      if (response) {
        await setForm((prevState) => ({
          ...prevState,
          success: true,
        }));
        dispatch(changeStatusSuccess())
      }
    } catch (error) {
      if (error?.data?.error_type === 'modal') {
        await setForm((prevState) => ({
          ...prevState,
          limitError: true,
          limitHeader: error?.data?.error_header ? error?.data?.error_header : 'Restore services',
          limitMessage: error?.data?.error_message ? error?.data?.error_message : 'You can not have more than 5 000 services.',
          isLoading: false,
        }));
        return;
      }
      const errorMessage = getErrorMessage(error);
      setForm((prevState) => ({
        ...prevState,
        isLoading: false,
        error: errorMessage,
      }));
    }
  };

  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        {error ? <div className="alert alert-danger">{error}</div> : null}
        <ModalConfirm.TitleDescriptionWrapper>
          {isLoading ? <Loader success={success} /> : null}
          {limitError
            ? (
              <>
                <ModalConfirm.Title>
                  {limitHeader}
                </ModalConfirm.Title>
                <ModalConfirm.Description>
                  <div>{limitMessage}</div>
                </ModalConfirm.Description>
              </>
            )
            : (
              <>
                <ModalConfirm.Title>
                  Change status
                  <div>
                    (Refill ID:
                    {' '}
                    {id}
                    )
                  </div>
                </ModalConfirm.Title>
                <ModalConfirm.Description>
                  <div>Are you sure you want to change the</div>
                  <div>
                    refill status to
                    {' '}
                    <b>{status?.title}</b>
                    ?
                  </div>
                </ModalConfirm.Description>
              </>
            )}
        </ModalConfirm.TitleDescriptionWrapper>
        <ModalConfirm.Actions>
          {limitError
            ? (
              <>
                <Button disabled={isLoading} onClick={onCloseModal}>
                  <span>Close</span>
                </Button>
              </>
            )
            : (
              <>
                <Button type="submit" bsStyle="primary" disabled={isLoading} onClick={onConfirm}>
                  <span>Change</span>
                </Button>
                <Button disabled={isLoading} onClick={onCloseModal}>
                  <span>Close</span>
                </Button>
              </>
            )}
        </ModalConfirm.Actions>
      </Modal.Body>
    </ModalConfirm.Wrapper>
  );
};

ModalChangeStatus.propTypes = {

};

export default ModalChangeStatus;
